import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import Button from '@material-ui/core/Button';
import intl from 'react-intl-universal';
import NotificationsRedux from './NotificationsRedux';

class NotificationProvider extends React.Component {
  state = {
    notifications: [],
  };

  storeDisplayed = key => {
    this.setState(({ displayed }) => ({
      displayed: [...displayed, key],
    }));
  };

  render() {
    return (
      <SnackbarProvider
        maxSnack={5}
        autoHideDuration={5000}
        ContentProps={{
          className: 'notifications-content',
        }}
        hideIconVariant={true}
        classes={{
          root: 'notifications-container',
          variantSuccess: 'circle-check-icon',
          variantError: 'circle-error-icon',
          message: 'notifications-content-message',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        action={[
          <Button key={0} size="small" style={{ textTransform: 'capitalize' }}>
            {intl.get('messaging.notifications.dismiss')}
          </Button>,
        ]}>
        <React.Fragment>
          {this.props.children}
          <NotificationsRedux />
        </React.Fragment>
      </SnackbarProvider>
    );
  }
}

export default withTheme(NotificationProvider);
